import { ButtonProps as suiButtonProps } from '@slal/ui/buttons';
import { ComponentPropsWithoutRef } from 'react';
import { StyledButton, StyledButtonGroup } from './styles';

export interface ButtonProps extends suiButtonProps {
    buttonVariant?: 'primary' | 'secondary' | 'tertiary';
}

export const Button = ({ buttonVariant = 'secondary', variant = 'outline', ...props }: ButtonProps) => (
    <StyledButton buttonVariant={buttonVariant} variant={variant} {...props} />
);

export const ButtonGroup = (props: ComponentPropsWithoutRef<'div'>) => <StyledButtonGroup {...props} />;
